import { setActiveTrace } from '../../../experience-trace-id-context';
import { generateSpanId } from '../generate-span-id';
export var setInteractionActiveTrace = function setInteractionActiveTrace(newId) {
  setActiveTrace(newId.replace(/-/g, ''), generateSpanId(), 'transition');
};